import React, { useEffect } from 'react';
import Immutable from 'immutable';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  Container,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
  ViewFilters,
  useViewFilterQuery,
  View,
} from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
  Pager as PageType,
  ImmutableRootState,
} from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';
import { ViewFilter, Pager } from '../../../components';
import {
  Filter,
  FilterProps,
} from '../../../components/ViewFilter';

import './style.scss';

interface ArticlesFilteredProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
  pager: Immutable.List<ImmutableEntity<PageType>>;
  filters: Filter[];
  classes: string;
  defaultFilterValues: Filter[];
  hideFilters?: boolean;
}

// eslint-disable-next-line max-len
const ArticlesFiltered: React.FC<ArticlesFilteredProps> = ({
  entities, pager, filters, classes, defaultFilterValues, hideFilters,
}) => {
  const { t } = useTranslation();

  const totalPages = Number(pager.getIn(['total_pages']));
  const { page, setCurrentPage, setFilters } = useViewFilterQuery();
  const currentPage: number = Number(page) + 1;
  const highlightedViewResultCount: number = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['view', 'article', 'highlight', 'pager', 'total_items'], 0));

  const componentClasses = classNames(classes, {
    'hide-filters': hideFilters,
  });

  useEffect(() => {
    setFilters(defaultFilterValues);
  }, [defaultFilterValues]);

  return (
    <FormikWrapper>
      <Container className={componentClasses}>
        <ViewFilters
          viewId="articles_filtered"
          display="default"
          onResetFilter={() => { }}
          onFilterUpdate={(field: any, value: any) => {
            setFilters({
              ...filters,
              [field]: value,
            });
          }}
          onRender={(data: FilterProps) => {
            const filterId = data.filter.get('id', null);
            const defaultValue = defaultFilterValues?.[filterId];

            return (
              <ViewFilter
                {...data}
                filters={filters}
                defaultValue={defaultValue}
              />
            );
          }}
        />

        {(entities.size === 0 && !(page === 0 && highlightedViewResultCount > 0)) && (
          <div className="View__Results__EmptyState">
            <h3>{t('pages.search.result_empty_title')}</h3>
            <p>{t('pages.search.result_empty_body')}</p>
          </div>
        )}

        {page === 0 && (
          <View
            classes="ViewArticlesFiltered_highlight"
            id="article"
            display="highlight"
            filters={filters}
          />
        )}

        <div className="row">
          {
            entities.map((entity, index) => {
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              const key = `${uuid}:${langcode}`;

              return (
                <div key={uuid} className="col-12 col-md-6 col-lg-4">
                  <Node
                    key={key}
                    entity={entity}
                    viewMode="teaser"
                  />
                </div>
              );
            })
          }
        </div>

        <div className="ViewArticlesFiltered__pager">
          <Pager
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        </div>
      </Container>
    </FormikWrapper>
  );
};

export default ArticlesFiltered;
